module.exports = __webpack_public_path__ + "c836fd93dfe2a11670c4f964ebdfd966.png";